import React, { useEffect, useMemo, useRef, useState } from "react";
import { Space, Spin, Table } from "antd";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tabKeys } from "types/enums";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";

import PatientInfo from "./PatientInfo/PatientInfo";
import Notification from "components/common/notification/notification";

import {
  AddService,
  Agree,
  Completed,
  CompletedPK,
  DisAgree,
  Pause,
  Save,
  SaveAndPrint,
} from "pages/Refractive/InforDetails/config";
import NurseOutInfo from "./NurseOutInfo/NurseOutInfo";
import CatalogList from "./CatalogList/CatalogList";
import ConsultantInfo from "./ConsultantInfo/ConsultantInfo";
import ListServiced from "./ListServiced/ListServiced";
import ModalAgree from "./Modal/ModalAgree";
import ModalDisAgree from "./Modal/ModalDisAgree";
import consultantAndFragmentService from "api/consulantAndFragtment";
import {
  setDataConsultantAndFragment,
  setIdConsultantInfo,
  setIdPhieuKhamTV,
} from "redux/reducer/consultantAndFragment";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import { StepInfo } from "components/common";
import ModalAddService from "./ModalAddService/ModalAddService";
import AddServicePacket from "./AddServicePacket/AddServicePacket";
import ConsulantAndFragtmentPrint from "../../../../components/common/PrintReceipt/ConsulantAndFragtmentPrint/ConsulantAndFragtmentPrint";
import Icons from "assets/icons";
import { columnsTableMenu } from "./NurseOutInfo/config";
import { examinationService } from "api";
import { disableBtn } from "helper/common";
import AlertModal from "components/common/AlertModal/AlertModal";

const DetailPatient = () => {
  const detailConsultantAndFragment = useAppSelector(
    (e) => e.consultantAndFragment.data
  );

  const showModalAgree = useAppSelector(
    (e) => e.consultantAndFragment.isShowModalAgree
  );

  const showModalDisAgree = useAppSelector(
    (e) => e.consultantAndFragment.isShowModalDisAgree
  );
  const [isShow, setIsShow] = useState(false);
  const modalRef = useRef<any>();
  const patientRef = useRef<any>();
  const modalAddService = useRef<any>();
  const [isShowModalAgree, setIsShowModalAgree] = useState(showModalAgree);
  const [dataServicePaket, setDataServicePaket] = useState<any>();
  const [total, setTotal] = useState(0);
  const [isShowModalDisAgree, setIsShowModalDisAgree] =
    useState(showModalDisAgree);
  const [params, setParams] = useState({
    page: 1,
    limit: 1000,
  });
  const modalAlertRef = useRef<any>();

  const [listButton, setListButton] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const activeKey = useAppSelector((state) => state.common.activeTab);
  const id = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantAndFragment
  );
  const idPK = useAppSelector((e) => e.consultantAndFragment.idPhieuKhamTV);
  const [loading, setLoading] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const getDetailsConsultantAndFragment = async () => {
    setLoading(true);
    try {
      const res =
        await consultantAndFragmentService.getDetailConsultantAndFragmentById(
          id
        );
      if (res?.trangThai === 1) {
        const newRes = postStatusConsultantAndFragmentForm(2);
        dispatch(setDataConsultantAndFragment(newRes));
      } else dispatch(setDataConsultantAndFragment(res));
      setDataDetail(res);
      dispatch(setIdPhieuKham(res.idPhieuKham));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  const postStatusConsultantAndFragmentForm = async (
    trangThai,
    name?,
    dis?
  ) => {
    setLoading(true);
    try {
      const params = {
        id: id,
        trangThai: trangThai,
      };
      // await handleSave();
      const res =
        await consultantAndFragmentService.updateStatusConsultantAndFragment(
          params
        );

      dispatch(setDataConsultantAndFragment(res));

      setLoading(false);

      if (trangThai !== 2) {
        Notification("success", `Cập nhật trạng thái ${name} thành công`);
      }

      dis
        ? dispatch(
            setActiveKey(
              tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT
            )
          )
        : "";
    } catch (error) {
      setLoading(false);

      Notification("error", `Cập nhật trạng thái ${name} thất bại`);
    }
  };

  const handleAgree = () => {
    setIsShowModalAgree({ type: "new", isShow: true });
    dispatch(setIdConsultantInfo(null));
  };

  const handlePause = async () => {
    if (detailConsultantAndFragment?.trangThai == 2) {
      await postStatusConsultantAndFragmentForm(1, " chờ thực hiện", true);
    } else {
      Notification(
        "warning",
        "Chỉ tạm dừng khi phiếu ở trạng thái Đang tư vấn"
      );
    }
  };
  const handelSaveAndPrint = () => {
    handleSave();
    modalRef?.current.openModal();
  };

  const handleSave = async () => {
    setLoading(true);
    const value = patientRef.current?.getFormValue();

    const newValue = {
      id: id,
      trangThai: value.trangThai,
      trangThaiThanhToan: detailConsultantAndFragment.trangThaiThanhToan,
      idPhieuKham: value.idPhieuKham,
      idPhieuChiDinh: detailConsultantAndFragment?.idPhieuChiDinh,
      bacSyChiDinh: value.bacSyChiDinh,
      nvTuVan: value.nvTuVan,
      ngayTao: detailConsultantAndFragment.ngayTao,
      phong: value.phong,
      loaiPhauThuat: value?.loaiPhauThuat,
      dayThanhToan: detailConsultantAndFragment?.dayThanhToan,
    };
    try {
      const res = await consultantAndFragmentService.updateDetail(newValue);
      Notification("success", "Cập nhật dữ liệu thành công");
      setLoading(false);
      dispatch(setDataConsultantAndFragment(res));
    } catch (error) {
      setLoading(false);
      Notification("error", "Cập nhật dữ liệu thất bại");
    }
  };

  const handleDisAgree = () => {
    dispatch(setIdConsultantInfo(null));
    setIsShowModalDisAgree({
      type: "new",
      isShow: true,
    });
  };

  const handleCompelted = async () => {
    const patientInfor = patientRef.current?.getFormValue();

    const res = disableBtn(patientInfor?.ngayTao);

    if (res) {
      modalAlertRef.current.openModal();
      setLoading(false);
      return;
    }
    await handleSave();
    postStatusConsultantAndFragmentForm(3, "hoàn thành", true);
    dispatch(setButtonsHeader([]));
  };

  const handleCompeltedKCB = async () => {
    // await handleCompelted();
    try {
      await examinationService.completeKCB(idPK);
      dispatch(
        setActiveKey(
          tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT
        )
      );
      dispatch(setIdPhieuKhamTV(null));
    } catch (error) {
      console.log("🚀 ~ handleCompeltedKCB ~ error:", error);
    }
    // dispatch(setButtonsHeader([]));
  };

  useMemo(() => {
    if (!id) {
      dispatch(
        setActiveKey(
          tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT
        )
      );
    }
  }, []);

  //lấy danh sách gọi gói dvu
  const getServicePacket = async () => {
    try {
      const res = await consultantAndFragmentService.getServicePacket(params);

      const newRes = res.data.map((item) => {
        return {
          ...item,
          key: item.id,
        };
      });

      setDataServicePaket(newRes);
      setTotal(res.total);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách gói dịch vụ ");
    }
  };

  const handleAddService = () => {
    modalAddService.current?.openModal();
  };

  useEffect(() => {
    getServicePacket();
  }, [params]);

  useEffect(() => {
    if (
      id !== null &&
      activeKey ==
        tabKeys.CONSULTANT_AND_FRAGMENT.DETAIL_CONSULTANT_AND_FRAGMENT
    ) {
      getDetailsConsultantAndFragment();
    }
    setIsShow(false);
  }, [id, activeKey]);

  useEffect(() => {
    if (
      listButton.length > 0 &&
      activeKey ==
        tabKeys.CONSULTANT_AND_FRAGMENT.DETAIL_CONSULTANT_AND_FRAGMENT
    ) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [listButton]);

  // useEffect(() => {
  //   if (
  //     activeKey !==
  //     tabKeys.CONSULTANT_AND_FRAGMENT.DETAIL_CONSULTANT_AND_FRAGMENT
  //   ) {
  //     dispatch(setButtonsHeader(listButton));
  //   } else dispatch(setButtonsHeader([]));
  // }, [activeKey]);

  useEffect(() => {
    setListButton([
      CompletedPK(handleCompeltedKCB),

      Save(handleSave),
      SaveAndPrint(handelSaveAndPrint, "Lưu và in"),
      AddService(handleAddService),
      Agree(handleAgree),
      DisAgree(handleDisAgree),
      // NextPatient(handleNextPatient),
      Completed(handleCompelted, "Hoàn thành tư vấn"),
      Pause(handlePause),
    ]);
  }, [detailConsultantAndFragment]);

  return (
    <Spin spinning={loading}>
      <div className="detail-diagnose">
        <div className="container">
          <div className="header">Thông tin bệnh nhân</div>
          <div className="container-main">
            <PatientInfo
              ref={patientRef}
              detailConsultantAndFragment={detailConsultantAndFragment}
            />
          </div>
        </div>

        <div className="container">
          <StepInfo />
        </div>

        <div className="container">
          <div className="header" style={{ paddingLeft: 0 }}>
            Thông tin khám ngoại trú
          </div>
          <NurseOutInfo data={dataDetail} />
        </div>
        {/* Gói dịch vụ BN lựa chọn */}
        <div className="container">
          <AddServicePacket />
        </div>
        {/* Thông tin tư vấn */}
        <div className="container">
          <ConsultantInfo />
        </div>
        <div className="container">
          <Space direction="vertical">
            <Space
              style={{
                fontWeight: "bold",
              }}
            >
              <div>Đơn thuốc</div>

              {isShow ? (
                <Icons.down onClick={() => setIsShow(!isShow)} />
              ) : (
                <Icons.up onClick={() => setIsShow(!isShow)} />
              )}
            </Space>
            {isShow && (
              <Table
                columns={columnsTableMenu}
                dataSource={dataDetail?.donThuocDto?.thuocs || []}
                bordered
                scroll={{ x: "100%", y: 300 }}
                pagination={false}
              />
            )}
          </Space>
        </div>
        {/* Danh sách hiện tại */}
        <div className="container">
          <CatalogList data={dataDetail} />
        </div>
        {/* Danh sách dịch vụ đã thực hiện */}
        <div className="container">
          <ListServiced data={dataDetail} />
        </div>
      </div>
      {isShowModalAgree.type === "new" ? (
        <ModalAgree
          patientRef={patientRef}
          isShowModalAgree={isShowModalAgree}
          setIsShowModalAgree={setIsShowModalAgree}
        />
      ) : undefined}
      {isShowModalDisAgree.type === "new" ? (
        <ModalDisAgree
          isShowModalDisAgree={isShowModalDisAgree}
          setIsShowModalDisAgree={setIsShowModalDisAgree}
        />
      ) : undefined}
      <ModalCustom ref={modalRef} centered width={1000}>
        <ConsulantAndFragtmentPrint />
      </ModalCustom>

      {dataServicePaket && (
        <ModalCustom ref={modalAddService} title="Chọn gói DV" width={2000}>
          <ModalAddService
            dataServicePaket={dataServicePaket}
            modalAddService={modalAddService}
            setParams={setParams}
            params={params}
          />
        </ModalCustom>
      )}
      {/* Cảnh báo quá hạn ngày */}
      <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom>
    </Spin>
  );
};

export default DetailPatient;
